<template>
    <div class="user-message">
        <div class="user-message__balloon">
            {{ props.interaction.content }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import type Interaction from '@/chat/types/Interaction';

    const props = defineProps<{ interaction: Interaction }>();
</script>

<style scoped lang="scss">
    .user-message {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        gap: .5rem;

        &__balloon {
            background-color: var(--color-balloon);
            color: var(--color-widget-text);
            border-radius: .5rem .5rem 0 .5rem;
            padding: 1rem;
            text-align: end;
        }
    }

    @media (min-width: 768px) {
        .user-message {
            &__balloon {
                max-width: 80%;
            }
        }
    }
</style>
